module.exports = __webpack_public_path__ + "img/lightbulb-b.svg";